var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBullhorn = function SvgBullhorn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.055 17.423 2 .05a1 1 0 0 0 .95-.62l.788-1.916a1 1 0 0 0-.262-1.128l-9.137-8.096a2 2 0 0 0-3.195.783l-3.041 7.957a2 2 0 0 0 1.817 2.713l3.627.093m6.453.164s.012 3.848-3.273 3.625-3.18-3.79-3.18-3.79m6.453.165-6.453-.164M6.707 5.87 5.543 3.625M4.94 8.406 2 6.71M4.656 11.2l-2.318.623"
  })));
};
export default SvgBullhorn;